import React, { useEffect, useState } from 'react'
import { MultiLevelSidebar } from '../Components/Layout/Sidebar'
import Testimonials from '../Components/Testimonial/TestimonialList'
import { collection, deleteDoc, doc, getDocs } from 'firebase/firestore'
import { db } from '../firebase.config'
const TestimonialList = () => {
    const [testimonials, setTestimonials] = useState([])
  const fetchProperties = async () =>{
    const querySnapshot = await getDocs(collection(db, "testimonial"));
    querySnapshot.forEach((doc) => {
     setTestimonials((prev)=>[...prev,{
      id:doc.id,
      ...doc.data()
     }])
   
  
    });
  }
  const deleteTestimonial = async (id) =>{
     await deleteDoc(doc(db, "testimonial", id))
    window.location.reload()
  
  }
  useEffect(() => {
   fetchProperties()
  }, [])
  return (
    <div>
        <MultiLevelSidebar />
        <Testimonials deleteTestimonial={deleteTestimonial} testimonial={testimonials} setTestimonials={setTestimonials}  />
    </div>
  )
}

export default TestimonialList